import { Component, Input, OnInit, OnDestroy, HostBinding, Output, EventEmitter, AfterViewInit } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import swal from 'sweetalert2';
import { BillingService } from '../../../services/billing.service';
import { getParamFromAncestorRoute, getQueryParamFromAncestorRoute } from '../../../utilities/route.utilities';


@Component({
    selector: 'read-data-availability-grid-item',
    templateUrl: './read-data-availability-grid-item.component.html',
})
export class ReadDataAvailabilityGridItem implements AfterViewInit, OnDestroy {

    subscriptions: any[] = [];
    timePeriod: number = 1;
    clientId: number;
    siteId: number;
    averageConsumption: any[] = [];
    hasData: boolean = false;
    hasLoading: boolean = true;

    constructor(
        private billingService: BillingService,
        private route: ActivatedRoute,
        private router: Router) {
    }

    ngAfterViewInit(): void {
        this.subscriptions.push(this.route.queryParams.subscribe(queryParams => {
            this.onInitialise();
        }));
    }

    onInitialise() {
        this.clientId = getParamFromAncestorRoute(this.route, 'clientId');
        this.timePeriod = getQueryParamFromAncestorRoute(this.route, 'timePeriod');
        this.siteId = getQueryParamFromAncestorRoute(this.route, 'siteId');
    }

    ngOnDestroy() {
    }

    onInfoClick() {
        swal({
            title: 'Meter reading frequency',
            html: '<p style="text-align: left;">Switch2 expects to receive at least one reading per day from each meter, depending on the equipment installed.</p>\
            <p style="text-align: left;">This widget shows the percentage of automated meter readings received on a daily or monthly basis.</p>\
            <p style="text-align: left;">We have displayed a benchmark and concern line to help you understand the connectivity of your meter portfolio.</p>\
            <p style="text-align: left;">If your percentage achieved is below either of the lines, you can look at Issues – Metering page for more detail. If in doubt, speak to our customer services team on 0333 321 2010.</p>',
            confirmButtonText: 'Close',
            confirmButtonColor: '#00539f'
        });
    }
}
